import { IconLoading1, IconLoadMore } from 'components/Icons'
import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { layoutSmall } from 'core/util/default'

interface LoadMoreCardProps {
  isLoading: boolean
  onClickLoadMore: () => void
}

const LoadMoreCard: React.FC<LoadMoreCardProps> = (props) => {
  const { onClickLoadMore, isLoading } = props
  const { t } = useTranslation()

  const loadMoreEl = useMemo(() => {
    if (isLoading) {
      return <IconLoading1 />
    }

    return (
      <>
        <IconLoadMore />
        <div>{t('more')}</div>
      </>
    )
  }, [isLoading, t])

  return (
    <StyledLoadMoreCard>
      <div className="card_loadmore_wrapper">
        <button onClick={onClickLoadMore}>{loadMoreEl}</button>
      </div>
    </StyledLoadMoreCard>
  )
}

const StyledLoadMoreCard = styled.div`
  .card_loadmore_wrapper {
    width: 274px;
    height: 366px;
    display: flex;
    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: inherit;
      height: 100%;
      background-color: transparent;
      border: none;
      color: ${(props) => props.theme.loading};
      cursor: pointer;
      > div {
        font-size: 14px;
        margin-top: 12px;
        color: ${(props) => props.theme.font.primary};
      }
      path:first-of-type {
        fill: ${(props) => props.theme.font.primary};
      }
      path:last-of-type {
        fill: ${(props) => props.theme.background};
      }
    }
  }

  ${layoutSmall(css`
    .card_loadmore_wrapper {
      width: 213px;
      height: 282px;
    }
  `)}
`
export default LoadMoreCard
